import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { guardarContexto, lerContexto } from '../api';
import { contextosDe, type OpcaoContexto } from '../contexto';
import { Logo } from '../componentes/Logo';

const ICONE: Record<OpcaoContexto['tipo'], string> = { admin: '⚙', escritorio: '📋', empresa: '🏢', softhouse: '🎧' };

/**
 * Uma pessoa pode ser admin, contador de um escritório e cliente de uma
 * empresa ao mesmo tempo. Nos moldes do soupsy: ela escolhe com qual
 * chapéu entra agora, e pode trocar depois pelo menu do perfil sem pedir
 * código de novo.
 */
export function EscolherContexto() {
  const { usuario } = useAuth();
  const nav = useNavigate();
  if (!usuario) return <Navigate to="/entrar" replace />;

  const opcoes = contextosDe(usuario);
  const atual = lerContexto();

  function escolher(o: OpcaoContexto) {
    guardarContexto(o);
    nav('/painel', { replace: true });
  }

  return (
    <div className="auth-split">
      <div className="auth-panel">
        <Logo tamanho={36} tamanhoFonte={24} tom="sobreAcento" />
        <div style={{ maxWidth: 460 }}>
          <h1 style={{ fontSize: 40, lineHeight: 1.1, letterSpacing: '-0.03em', marginBottom: 16 }}>
            Como você quer entrar?
          </h1>
          <p style={{ fontSize: 17, lineHeight: 1.65 }}>
            Seu celular está ligado a mais de uma conta no Conti9. Escolha uma — dá para trocar
            depois sem pedir código de novo.
          </p>
        </div>
        <div className="copyright">© 2026 Conti9 · um produto <strong>Grupo Atendi9</strong></div>
      </div>

      <div className="auth-form-wrap">
        <div className="auth-form fade-up">
          <h2 style={{ fontSize: 29, letterSpacing: '-0.03em', marginBottom: 20 }}>Entrar como</h2>

          <div className="opcoes">
            {opcoes.map((o) => (
              <button
                key={`${o.tipo}:${o.id ?? ''}`}
                className={`opcao ${atual && atual.tipo === o.tipo && atual.id === o.id ? 'ativa' : ''}`}
                onClick={() => escolher(o)}
              >
                <strong>{ICONE[o.tipo]} {o.rotulo}</strong>
                <span>{o.detalhe}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
